import { CardSkeleton, DashCard } from "../DashboardCards";
import { COLORS } from "../../configs/config";
import { Box, Typography } from "@mui/material";

export const AlertsChart = ({ data, loading }) => {
    if (loading) return <CardSkeleton height={140} />;

    const items = [
        { icon: "⚠️", label: "CAs a vencer (30d)",   valor: data?.vencimentoCAperiodo?.quantidade    ?? 0, color: COLORS.amber },
        { icon: "❌", label: "CAs vencidos",          valor: data?.CAVencidos?.quantidade             ?? 0, color: COLORS.red   },
        { icon: "👷", label: "EPIs vencidos (func.)", valor: data?.totalEpisVencidos?.quantidade      ?? 0, color: COLORS.red   },
        { icon: "📡", label: "Equip. desconectados",  valor: data?.equipDisconnect?.quantidade        ?? 0, color: COLORS.tDim  },
        { icon: "📦", label: "Estoque baixo",          valor: data?.equipamentoEstoqueBaixo?.quantidade ?? 0, color: COLORS.amber },
    ];

    return (
        <DashCard title="Alertas operacionais">
            <Box display="flex" flexDirection="column" gap={1}>
                {items.map((a, i) => (
                    <Box
                        key={i}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                            py: 0.75,
                            borderBottom: i < items.length - 1 ? `0.5px solid ${COLORS.border}` : "none",
                        }}
                    >
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography sx={{ fontSize: 14 }}>{a.icon}</Typography>
                            <Typography variant="caption" sx={{ color: COLORS.tDim }}>{a.label}</Typography>
                        </Box>
                        <Typography variant="body2" sx={{
                            color: a.valor > 0 ? a.color : COLORS.g2,
                            fontWeight: 700,
                        }}>
                            {a.valor}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </DashCard>
    );
};